import { mapValues } from 'radash';
import '../tokens/border-radiuses.js';
import { colors } from '../tokens/colors.js';
import '../tokens/font-sizes.js';
import '../tokens/gaps.js';
import '../tokens/heights.js';
import '../tokens/spacings.js';
import '../tokens/widths.js';
import { colorAliases } from './colors.js';

/**
 * Collection of alias tokens for background colors. Designed to color the backgrounds of sites and
 * applications in different color modes.
 */ const backgroundColorAliases = {
    light: mapValues(colors, (color)=>color[50]),
    dark: {
        ...mapValues(colors, (color)=>color[950]),
        gray: colors[colorAliases.neutral][900]
    }
};

export { backgroundColorAliases };
//# sourceMappingURL=background-colors.js.map
